import { sqliteTable, text, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// employees — ทะเบียนพนักงาน (Employee Registry)
// ============================================================================
export const employees = sqliteTable("hr_employees", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  employeeCode: text("employee_code").notNull(),
  firstName: text("first_name").notNull(),
  lastName: text("last_name").notNull(),
  nickname: text("nickname"),
  idCardNumber: text("id_card_number"), // เลขบัตรประชาชน 13 หลัก
  dateOfBirth: text("date_of_birth"),
  gender: text("gender"), // male, female, other
  nationality: text("nationality"),
  phone: text("phone"),
  email: text("email"),
  address: text("address"),
  emergencyContact: text("emergency_contact"), // JSON string: {name, phone, relation}
  departmentId: text("department_id"),
  designationId: text("designation_id"),
  employmentType: text("employment_type").notNull().default("full_time"), // full_time, part_time, contract
  joinDate: text("join_date"),
  confirmDate: text("confirm_date"),
  resignDate: text("resign_date"),
  bankAccountNo: text("bank_account_no"),
  bankCode: text("bank_code"),
  socialSecurityNo: text("social_security_no"),
  taxId: text("tax_id"),
  salary: integer("salary"),
  salaryStructureId: text("salary_structure_id"),
  userId: text("user_id"), // Link to core.users (optional)
  status: text("status").notNull().default("active"), // active, resigned, terminated
  isActive: integer("is_active").notNull().default(1),
  branchId: text("branch_id"),
  // Audit columns
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  emp_company_idx: index("emp_company_idx").on(table.companyId, table.isActive),
  emp_department_idx: index("emp_department_idx").on(table.companyId, table.departmentId),
  emp_code_idx: index("emp_code_idx").on(table.companyId, table.employeeCode),
}));

// Type exports
export type Employee = typeof employees.$inferSelect;
export type NewEmployee = typeof employees.$inferInsert;
